export default __webpack_public_path__ + "static/media/cooper-2.5e8cc1fc.jpg";